<template>
    <button :type="type"
            :class="{ 'opacity-25': processing }" :disabled="processing"
            @click="$emit('click')"
            class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150">
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        processing: {
            type: Boolean,
            default: false
        }
    }
}
</script>
